import React from 'react'
import ForgotPassword from '../components/ForgotPassword'

const ForgotPasswordPage = () => <ForgotPassword />

export default ForgotPasswordPage
